import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';
import { LayoutWrapper, NotFound, Loading } from './components';

// Client Pages
const Contact = React.lazy(() => import('./pages/appointments'));
const Furnitures = React.lazy(() => import('./pages/furnitures'));
const Furniture = React.lazy(() => import('./pages/furniture'));
const Home = React.lazy(() => import('./pages/home'));
const Products = React.lazy(() => import('./pages/products'));
const Project = React.lazy(() => import('./pages/project'));
const Projects = React.lazy(() => import('./pages/projects'));
const Residentials = React.lazy(() => import('./pages/residentials'));
const Commercial = React.lazy(() => import('./pages/commercial'));
const Services = React.lazy(() => import('./pages/services'));
const Catalogs = React.lazy(() => import('./pages/catalogs'));
const Factory = React.lazy(() => import('./pages/factory'));
const Clients = React.lazy(() => import('./pages/clients'));
const ShopManager = React.lazy(() => import('./pages/shopperManager'));

const App = (props) => {
  const clientRoutes = [
    {
      component: (props) => <Products {...props} />,
      exact: true,
      path: '/productos',
    },
    {
      component: (props) => <Contact {...props} />,
      exact: true,
      path: '/contacto',
    },
    {
      component: (props) => <Services {...props} />,
      exact: true,
      path: '/servicios',
    },
    {
      component: (props) => <Catalogs {...props} />,
      exact: true,
      path: '/catalogos',
    },
    {
      component: (props) => <Furnitures {...props} />,
      exact: true,
      path: '/catalogo',
    },
    {
      component: (props) => <Furniture {...props} />,
      exact: false,
      path: '/producto/:slug',
    },
    {
      component: (props) => <Home {...props} />,
      exact: true,
      path: '/',
    },
    {
      component: (props) => <ShopManager {...props} />,
      exact: true,
      path: '/asistente-de-compras',
    },
    {
      component: (props) => <Projects {...props} />,
      exact: true,
      path: '/proyectos',
    },
    {
      component: (props) => <Project {...props} />,
      exact: false,
      path: '/proyecto/:slug',
    },
    {
      component: (props) => <Residentials {...props} />,
      exact: false,
      path: '/proyectos-residenciales',
    },
    {
      component: (props) => <Commercial {...props} />,
      exact: false,
      path: '/proyectos-comerciales',
    },
    {
      component: (props) => <Factory {...props} />,
      exact: false,
      path: '/fabrica',
    },
    {
      component: (props) => <Clients {...props} />,
      exact: false,
      path: '/clientes',
    },
  ].map((route) => {
    route.key = btoa(`${route.exact}-${route.path}`).replace(/(=)/g, '');
    return route;
  });

  return (
    <React.Suspense fallback={<Loading />}>
      <Router>
        <Switch>
          {/* Regular Routes */}
          {clientRoutes.map(({ component, exact, path, key }) => (
            <Route
              component={(props) => (
                <LayoutWrapper {...props}>{component(props)}</LayoutWrapper>
              )}
              exact={exact}
              path={path}
              key={key}
            />
          ))}
          {/* 404 Routes */}
          <Route component={NotFound} />
        </Switch>
      </Router>
    </React.Suspense>
  );
};

export default withRouter(App);
